import { defineStore } from 'pinia'
import SensorInjectionState, { SensorInjectionStateType } from './state'
import { SensorInjectionActions, SensorInjectionActionsType } from './actions'
import { SensorInjectionGetters } from './getters'

export const useSensorInjectionStore = defineStore<
  'sensorInjection',
  SensorInjectionStateType,
  typeof SensorInjectionGetters,
  SensorInjectionActionsType
>('sensorInjection', {
  state: SensorInjectionState,
  actions: SensorInjectionActions,
  getters: SensorInjectionGetters,
})
